import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
//import IconButton from '@material-ui/core/IconButton'
//import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

//import ReactTooltip from "react-tooltip"


const styles = theme => ({
  languageSelector: {
    textAlign: 'center',
    fontSize: '16pt',
    fontFamily:'Nunito Sans Regular',
    margin:'5px',
    borderRadius:'5px!important'
  },
  //questionContainer: {
  //  padding: theme.spacing() * 1.5,
  //  textAlign: 'center',
  //   color: theme.palette.text.secondary,
  //},
  hooverable: {
    textDecoration: 'none',
    '&:hover': {
      //color: 'white!important',
      cursor: 'pointer',
    },
  },
  //toolTipIconButton: {
  //  marginLeft: '5px',
  //  width: '24px',
  //  height: '24px',
  //  alignSelf: 'center!important',
  //},
  //toolTip: {
  //  textAlign: 'left',
  //  color: '#105269!important',
  //  backgroundColor: '#aaaaaa',
  //  fontFamily: 'Nunito Sans!important',
  //},
});

function LanguageSelector(props) {
  const { classes } = props;

  return (
    <Grid item container 
      xs={12} 
      //sm={5} 
      //md={3}
    >
      <Grid item xs={4}>
        <Paper
          className={classes.languageSelector + " " + classes.hooverable + " " + (props.lang==="en"?' bggreenblue activeHeaderText':' bgmediumgrey mediumgreen ')}
          onClick={() => props.changeLanguage("en")}
        >
          EN
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          className={classes.languageSelector + " " +  classes.hooverable + " " + (props.lang==="fr"?' bggreenblue activeHeaderText':' bgmediumgrey mediumgreen ')}
          onClick={() => props.changeLanguage("fr")}
        >
          FR
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper
          className={classes.languageSelector + " " + classes.hooverable + " " + (props.lang==="de"?' bggreenblue activeHeaderText':' bgmediumgrey mediumgreen ')}
          onClick={() => props.changeLanguage("de")}
        >
         DE
        </Paper>
      </Grid>
    </Grid>
  );

}

LanguageSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LanguageSelector);

